export default __webpack_public_path__ + "images/CPHAIRTAXI.27b6cba.png";